// import IndexLayout from "@layout/IndexLayout.vue";
import Index from "@views/index/Index.vue";
import NotHomePage from "@layout/NotHomePage.vue";
import Search from "@views/Search.vue";
import CourseDetail from "@views/course/CourseDetail.vue";
import CourseStudy from "@views/course/CourseStudy.vue";
import courseOnlineDetail from "@views/live-online/CourseLiveOnlineDetail.vue";
import courseOnlineStudy from "@views/live-online/CourseLiveOnlineStudy.vue";
import Personal from "@views/Personal.vue";
import ExclusiveCourses from "@views/ExclusiveCourses.vue";
import PayDetail from "@views/PayDetail.vue";
import courseDirection from "@views/study-direction/CourseDirection.vue";

export const routes =[
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: "/index",
        component: Index,
        name: 'index'
    },
    {
        path: '/other',
        name: 'notHomePage',
        component: NotHomePage,
        children: [
            {
                path: "search",
                name: 'search',
                component: Search
            }, {
                name: 'courseDetail',
                path: "course/detail/:courseId",
                component: CourseDetail
            }, {
                name: 'courseStudy',
                path: "course/study/:courseId",
                component: CourseStudy,
                meta: {
                    // 对于课程学习界面，免费课程可以不登陆就访问
                    // needLogin: true
                }
            }, {
                name: 'courseOnlineDetail',
                path: "course/online/detail/:courseId",
                component: courseOnlineDetail
            }, {
                name: 'courseOnlineStudy',
                path: "course/online/study/:courseId",
                component: courseOnlineStudy,
                meta: {
                    needLogin: true
                }
            },
            {
                path: "personal/:activeKey",
                component: Personal,
                meta: {
                    needLogin: true
                }
            }, {
                path: "exclusiveCourses",
                component: ExclusiveCourses,
                name: 'exclusiveCourses'
            }, {
                name: 'payDetail',
                path: "pay-detail/:orderId",
                component: PayDetail,
                meta: {
                    needLogin: true
                }
            }, {
                path: "shopping-cart",
                component: () => import('@views/pay/ShoppingCart.vue'),
                meta: {
                    needLogin: true
                }
            }, {
                path: "pay-succeed",
                component: () => import('@views/pay/PaySucceed.vue'),
                meta: {
                    needLogin: true
                }
            }, {
                name: 'articleDetail',
                path: "article/detail/:id",
                component: () => import('@views/article/ArticleDetail.vue')
            }, {
                name: 'course-direction-bigData',
                path: "course-direction-bigData",
                component: () => import('@views/study-direction/CourseDirectionBigData.vue')
            }, {
                name: 'course-direction-web',
                path: "course-direction-web",
                component: () => import('@views/study-direction/CourseDirectionWeb.vue')
            }

            , {
                name: 'course-direction-detail',
                path: "course-direction-detail",
                component: () => import('@views/study-direction/CourseDirectionDetail.vue'),
                meta: {
                    needLogin: true
                }
            }, {
                path: "course-direction",
                component: courseDirection,
                name: 'course-direction'
            }, {
                path: "article",
                component: () => import('@views/article/Article.vue'),
            },
            {
                path:'member-ship',
                component: ()=>import('@views/member-ship/index.vue')
            },
            {
                path:'member-equity',
                component: ()=>import('@views/member-equity/index.vue')
            }
        ]
    }
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '@views/About.vue')
    // }
];
